/* Shop: Shopify storefront filters, sort and paging, swapped in place via the Section Rendering API (plain links without JS). */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const sx = () => $('#sx');
  const sid = () => sx().dataset.section;
  async function load(url, push = true) {
    const u = new URL(url, location.origin); u.searchParams.set('section_id', sid());
    sx().classList.add('sx-busy');
    const html = await fetch(u).then((r) => r.text()).catch(() => null);
    if (!html) { location.href = url; return; }
    const d = new DOMParser().parseFromString(html, 'text/html');
    const next = $('#sx', d); if (!next) { location.href = url; return; }
    const open = [...document.querySelectorAll('.sx-g.open')].map((g) => g.dataset.g), side = $('#sxSide')?.classList.contains('open');
    sx().replaceWith(next); window.LLfav?.paint();
    open.forEach((k) => $(`.sx-g[data-g="${CSS.escape(k)}"]`)?.classList.add('open'));
    if (side) $('#sxSide').classList.add('open'); // phone: keep the filter sheet open until Show results
    if (push) { u.searchParams.delete('section_id'); history.pushState({}, '', u); }
  }
  function formUrl() {
    const f = $('#sxSide'), fd = new FormData(f), u = new URL(f.action, location.origin);
    for (const [k, v] of fd) if (v !== '' && k !== '_price') u.searchParams.append(k, v);
    return u.toString();
  }
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t.name === '_price') { const [lo, hi] = t.value.split('-'); $('[data-pmin]').value = lo === '0' ? '' : lo; $('[data-pmax]').value = hi && hi !== lo ? hi : ''; }
    if (t.closest('#sxSide')) load(formUrl());
  });
  document.addEventListener('submit', (e) => { if (e.target.id === 'sxSide') { e.preventDefault(); document.body.classList.remove('sx-lock'); $('#sxSide').classList.remove('open'); load(formUrl()); } });
  document.addEventListener('input', (e) => {
    if (!e.target.classList.contains('sx-bq')) return;
    const q = e.target.value.toLowerCase();
    e.target.parentElement.querySelectorAll('.sx-opt').forEach((l) => (l.hidden = q && !l.textContent.toLowerCase().includes(q)));
  });
  document.addEventListener('click', async (e) => {
    const t = e.target;
    const gh = t.closest('.sx-gh'); if (gh) { const g = gh.parentElement, open = !g.classList.contains('open'); gh.setAttribute('aria-expanded', String(open)); window.LLu.swing(g, (v) => g.classList.toggle('open', v), open); return; }
    const chip = t.closest('[data-chip]'); if (chip) { e.preventDefault(); return load(chip.href); }
    document.querySelectorAll('.sx-sortd[open]').forEach((d) => { if (!d.contains(t)) window.LLu.shut(d); });
    const so = t.closest('[data-sort]');
    if (so) { window.LLu.shut(so.closest('details')); $('#sxSide [name=sort_by]').value = so.dataset.sort; return load(formUrl()); }
    const pgl = t.closest('[data-page]');
    if (pgl) {
      e.preventDefault(); await load(pgl.href);
      scrollTo({ top: sx().getBoundingClientRect().top + scrollY - 160, behavior: 'smooth' });
      return;
    }
    if (t.closest('#sxOpen')) { $('#sxSide').classList.add('open'); document.body.classList.add('sx-lock'); }
    if (t.closest('#sxClose')) { $('#sxSide').classList.remove('open'); document.body.classList.remove('sx-lock'); }
  });
  // the sort button wraps to either end of the bar, so open the menu toward whichever side has room
  addEventListener('toggle', (e) => { const d = e.target; if (!d.open || !d.classList?.contains('sx-sortd')) return; const l = d.querySelector('.sx-sortl'); l.classList.remove('flip'); if (l.getBoundingClientRect().right > document.documentElement.clientWidth) l.classList.add('flip'); }, true);
  addEventListener('keydown', (e) => { if (e.key === 'Escape') document.querySelectorAll('.sx-sortd[open]').forEach((d) => window.LLu.shut(d)); });
  addEventListener('popstate', () => load(location.href, false));
})();
